export default __webpack_public_path__ + "static/thumbnail-portrait-generic-cd45fc29f191e7c02e894d57a7dc8ff1.jpg";